import {createReducer, on} from '@ngrx/store';
import {
  updateSelectedUserRoleByOrganizationId,
  saveSelectedUserRole,
  saveUserRoles,
  saveUserLanguage,
  saveUserPermissions,
} from './user-info.actions';
import {UserInfoStore} from './user-info.state';
import {initialState} from './user-info.state';

export const userInfoReducer = createReducer(
  initialState,
  on(
    updateSelectedUserRoleByOrganizationId,
    (state, {organizationId}): UserInfoStore => ({
      ...state,
      selectedUserRole: state.userRoles.find(
        (userRole) => userRole.organizationId === organizationId,
      ),
    }),
  ),
  on(
    saveSelectedUserRole,
    (state, {userRole}): UserInfoStore => ({
      ...state,
      selectedUserRole: userRole,
    }),
  ),
  on(
    saveUserRoles,
    (state, {userRoles}): UserInfoStore => ({
      ...state,
      userRoles,
    }),
  ),
  on(
    saveUserLanguage,
    (state, {language}): UserInfoStore => ({
      ...state,
      userLanguage: language,
    }),
  ),
  on(
    saveUserPermissions,
    (state, {permissions}): UserInfoStore => ({
      ...state,
      userPermissions: permissions,
    }),
  ),
);

export const userInfoReducers = {
  userInfo: userInfoReducer,
};
